// extracted by mini-css-extract-plugin
export default {"cls1":"Unibrow-cls1___bfbaf8b88b5eacb06a5","cls2":"Unibrow-cls2___5f1cdb1afb671f157a1 Unibrow-cls1___bfbaf8b88b5eacb06a5"};